import { CheckNetworkOutlineIcon } from './CheckNetworkOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 98A3D662-2D11-40DB-8557-E1DD0E877091
 * name check-network-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-network-outline.svg
 * tags
 */
export const TickNetworkOutlineIcon = CheckNetworkOutlineIcon;
export default TickNetworkOutlineIcon